import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Error from '../error/Error';

var selectAll = function selectAll(node) {
  setTimeout(function () {
    node.setSelectionRange(0, node.value.length);
  }, 5);
};

var setFocus = function setFocus(node) {
  node.focus();
  selectAll(node);
};

var utils = function utils(_ref) {
  var leadingZero = _ref.leadingZero,
      useUTC = _ref.useUTC;
  return {
    getDay: function getDay(date) {
      return "".concat(leadingZero ? '0' : '').concat(useUTC ? date.getUTCDate() : date.getDate()).slice(-2);
    },
    getMonth: function getMonth(date) {
      return "".concat(leadingZero ? '0' : '').concat((useUTC ? date.getUTCMonth() : date.getMonth()) + 1).slice(-2);
    },
    getYear: function getYear(date) {
      return useUTC ? date.getUTCFullYear() : date.getFullYear();
    }
  };
};

var getDateItem = function getDateItem(value, useUTC, leadingZero) {
  var _utils = utils({
    leadingZero: leadingZero,
    useUTC: useUTC
  }),
      getDay = _utils.getDay,
      getMonth = _utils.getMonth,
      getYear = _utils.getYear; // undefined and null should return an empty string (invalid date)


  var date = new Date(value || '');
  var invalid = Number.isNaN(date.getDate());
  var day = invalid ? '' : getDay(date);
  var month = invalid ? '' : getMonth(date);
  var year = invalid ? '' : getYear(date).toString();
  return {
    day: day,
    month: month,
    year: year
  };
};

var inputBuilder = function inputBuilder(context, name, placeholder, maxLength, label) {
  var controlName = context.props.name;
  var id = "".concat(controlName, "-").concat(name);
  var description = "".concat(label, " - ").concat(name);
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("label", {
    className: "tes-simple-date__label",
    htmlFor: id
  }, description), context.props.displayControlsLabel && !!context.state[name] &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/label-has-for
  React.createElement("label", {
    className: "tes-simple-date__label-control",
    htmlFor: id
  }, placeholder), /*#__PURE__*/React.createElement("input", {
    id: id,
    "data-testid": id,
    className: "tes-simple-date__item tes-simple-date__".concat(name),
    onClick: function onClick(e) {
      return selectAll(e.target);
    },
    onKeyDown: function onKeyDown(e) {
      return context.focusNext(e, name);
    },
    ref: function ref(_ref2) {
      context[name] = _ref2;
    },
    onChange: function onChange(e) {
      return context.onChange(e, name, maxLength);
    },
    size: maxLength,
    value: context.state[name],
    placeholder: placeholder,
    disabled: context.props.disabled
  }));
};

inputBuilder.displayName = "inputBuilder";

var SimpleDate = /*#__PURE__*/function (_Component) {
  _inherits(SimpleDate, _Component);

  var _super = _createSuper(SimpleDate);

  function SimpleDate() {
    var _this;

    _classCallCheck(this, SimpleDate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", getDateItem(_this.props.value, _this.props.useUTC, _this.props.leadingZero));

    var sequence = _this.props.sequence;
    _this.nextItems = sequence.reduce(function (obj, cur, index, arr) {
      obj[cur] = arr[index + 1];
      return obj;
    }, {});
    _this.previousItems = sequence.reduce(function (obj, cur, index, arr) {
      obj[cur] = arr[index - 1];
      return obj;
    }, {});
    return _this;
  }

  _createClass(SimpleDate, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state = this.state,
          year = _this$state.year,
          month = _this$state.month,
          day = _this$state.day;

      if (prevState.day === day && prevState.month === month && prevState.year === year) {
        return;
      }

      var onChange = this.props.onChange;

      if (onChange) {
        onChange("".concat(year, "-").concat(month, "-").concat(day));
      }
    }
  }, {
    key: "onChange",
    value: function onChange(evt, current, maxLength) {
      var nextItem = this.nextItems[current]; // const previousItem = this.previousItems[current];

      var currentValue = this[current].value;

      if (new RegExp("^[0-9]{0,".concat(maxLength, "}$")).test(currentValue)) {
        this.setState(_defineProperty({}, current, currentValue));

        if (nextItem && currentValue.length >= maxLength) {
          setFocus(this[nextItem]);
        }
      }
    }
  }, {
    key: "focusNext",
    value: function focusNext(evt, current) {
      var nextItem = this.nextItems[current];
      var previousItem = this.previousItems[current];
      var currentValue = this[current].value;

      if (nextItem) {
        if (evt.key === '/' || evt.key === '-' || evt.key === 'ArrowRight' && evt.target.selectionStart === currentValue.length) {
          setFocus(this[nextItem]);
        }
      }

      if (previousItem) {
        if (evt.key === 'ArrowLeft' && evt.target.selectionStart === 0) {
          setFocus(this[previousItem]);
        } else if (currentValue.length === 0 && evt.key === 'Backspace') {
          setFocus(this[previousItem]);
          evt.preventDefault();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var day = inputBuilder(this, 'day', 'DD', 2, this.props.label);
      var month = inputBuilder(this, 'month', 'MM', 2, this.props.label);
      var year = inputBuilder(this, 'year', 'YYYY', 4, this.props.label);
      var dateComponents = {
        day: day,
        month: month,
        year: year
      };
      var sequence = this.props.sequence || ['day', 'month', 'year'];
      var _this$props = this.props,
          classNames = _this$props.classNames,
          error = _this$props.error,
          disabled = _this$props.disabled;
      var cssClass = classnames({
        'tes-simple-date': true,
        'tes-simple-date--has-error': error,
        'tes-simple-date--is-disabled': disabled
      }, classNames);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: cssClass
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: this.props.name,
        value: this.props.value
      }), dateComponents[sequence[0]], "/", dateComponents[sequence[1]], "/", dateComponents[sequence[2]]), error ? /*#__PURE__*/React.createElement(Error, {
        error: error
      }) : null);
    }
  }]);

  return SimpleDate;
}(Component);

SimpleDate.displayName = "SimpleDate";

_defineProperty(SimpleDate, "propTypes", {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sequence: PropTypes.arrayOf(PropTypes.string),
  classNames: PropTypes.string,
  error: PropTypes.node,
  disabled: PropTypes.bool,
  // eslint-disable-line react/no-unused-prop-types
  useUTC: PropTypes.bool,
  leadingZero: PropTypes.bool,
  displayControlsLabel: PropTypes.bool // eslint-disable-line react/no-unused-prop-types

});

_defineProperty(SimpleDate, "defaultProps", {
  disabled: false,
  useUTC: false,
  sequence: ['day', 'month', 'year'],
  error: '',
  classNames: null,
  leadingZero: false,
  displayControlsLabel: false
});

export { SimpleDate as default };